import { api } from "../api";

export const mastersOfTradingThankyou = (formData: any, prevResponse: any) => {
  api.forms.triggerEvents({
    events: ["App\\Events\\MastersOfTrading"],
    fields: {
      formData,
      callResponse: prevResponse
    }
  });
};
